import React from "react";
import { useDispatch } from "react-redux";
import { setDetailBalance } from "../../../store/siteSlice";
import { useTranslation } from "react-i18next";
import { TEST_MODE } from "../../../store/enums";
import { setCurrency } from "../../../store/userSlice";
import ShowContainer from "../ShowContainer";
import useBalance from "../../../hooks/useBalance";

export default function ChooseCurrencyPlug({ currencyKey, currency, onChange, setOpen }) {
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const { getMainBalance, getBonusBalance } = useBalance();

  const bonusBalance = getBonusBalance(currencyKey);
  const mainBalance = getMainBalance(currencyKey)?.toLocaleString();
  const bonusBalanceString = bonusBalance?.toLocaleString();

  const isActive = currencyKey === currency;
  const activeClass = isActive ? "active" : "";

  const onBalanceClick = () => dispatch(setDetailBalance(true));

  const changeCurrency = (currency) => {
    if (TEST_MODE) {
      console.log(currency);
      dispatch(setCurrency(currency));
      return;
    }

    if (onChange) {
      onChange(currency);
      return;
    }

    dispatch(setCurrency(currency));
  };

  return (
    <li
      onClick={() => {
        changeCurrency(currencyKey);
        setOpen(false);
      }}>
      <button className={`currency-item ${activeClass}`}>
        <div className="main">
          <span className="balance-value">
            <button onClick={onBalanceClick} className="main number-link">
              {mainBalance}
            </button>
          </span>
          <span className="currency">{currencyKey}</span>
        </div>
        <ShowContainer condition={!!+bonusBalance}>
          <div className="bonus">
            <span className="bonus-row">
              {t("bonus: ")}
              <button className="number-link" onClick={onBalanceClick}>
                {bonusBalanceString}
              </button>
            </span>
          </div>
        </ShowContainer>
      </button>
    </li>
  );
}
